const _headwear = {
	'acorn-knit-cap': {
		name: 'acorn knit cap',
		variations: {
			chestnut: 'Chestnut',
			mustard: 'Mustard',
			avocado: 'Avocado',
			'berry-red': 'Berry red',
			'navy-blue': 'Navy blue',
			cream: 'Cream',
		},
	},
	'alpinist-hat': {
		name: 'alpinist hat',
		variations: {
			green: 'Green',
			blue: 'Blue',
			red: 'Red',
		},
	},
	'ancient-administrator-hat': {
		name: 'ancient administrator hat',
		variations: {
			black: 'Black',
		},
	},
	'apple-hat': {
		name: 'apple hat',
		variations: {
			red: 'Red',
		},
	},
	'aran-knit-cap': {
		name: 'Aran-knit cap',
		variations: {
			white: 'White',
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
		},
	},
	'babys-hat': {
		name: "baby's hat",
		variations: {
			'baby-mint': 'Baby mint',
			'baby-purple': 'Baby purple',
			'baby-yellow': 'Baby yellow',
			'baby-green': 'Baby green',
			'baby-pink': 'Baby pink',
			'baby-gray': 'Baby gray',
			'baby-blue': 'Baby blue',
			'baby-orange': 'Baby orange',
		},
	},
	'balloon-hat': {
		name: 'balloon hat',
		variations: {
			rainbow: 'Rainbow',
			orange: 'Orange',
			blue: 'Blue',
			green: 'Green',
		},
	},
	'bamboo-hat': {
		name: 'bamboo hat',
		variations: {
			beige: 'Beige',
		},
	},
	barrette: {
		name: 'barrette',
		variations: {
			pink: 'Pink',
		},
	},
	'baseball-cap': {
		name: 'baseball cap',
		variations: {
			red: 'Red',
			'navy-blue': 'Navy blue',
			green: 'Green',
			orange: 'Orange',
			yellow: 'Yellow',
		},
	},
	'batters-helmet': {
		name: "batter's helmet",
		variations: {
			red: 'Red',
			'navy-blue': 'Navy blue',
			green: 'Green',
			orange: 'Orange',
			yellow: 'Yellow',
		},
	},
	'bear-cap': {
		name: 'bear cap',
		variations: {
			brown: 'Brown',
			black: 'Black',
			pink: 'Pink',
			blue: 'Blue',
		},
	},
	beret: {
		name: 'beret',
		variations: {
			'berry-red': 'Berry red',
			blue: 'Blue',
			green: 'Green',
			mustard: 'Mustard',
			gray: 'Gray',
			white: 'White',
		},
	},
	'bicycle-helmet': {
		name: 'bicycle helmet',
		variations: {
			blue: 'Blue',
			'navy-blue': 'Navy blue',
			red: 'Red',
			lime: 'Lime',
			green: 'Green',
			orange: 'Orange',
			purple: 'Purple',
			pink: 'Pink',
		},
	},
	'birthday-hat': {
		name: 'birthday hat',
		variations: {
			blue: 'Blue',
			yellow: 'Yellow',
			pink: 'Pink',
		},
	},
	'blue-rose-crown': {
		name: 'blue rose crown',
		variations: {
			blue: 'Blue',
		},
	},
	'bowler-hat-with-ribbon': {
		name: 'bowler hat with ribbon',
		variations: {
			blue: 'Blue',
			beige: 'Beige',
			green: 'Green',
			red: 'Red',
			pink: 'Pink',
		},
	},
	'bun-wig': {
		name: 'bun wig',
		variations: {
			pink: 'Pink',
			blue: 'Blue',
			mustard: 'Mustard',
			white: 'White',
			purple: 'Purple',
			green: 'Green',
			orange: 'Orange',
		},
	},
	'bunny-day-crown': {
		name: 'Bunny Day crown',
		variations: {
			na: 'NA',
		},
	},
	'bunny-ears': {
		name: 'bunny ears',
		variations: {
			black: 'Black',
			pink: 'Pink',
			red: 'Red',
			'light-blue': 'Light blue',
		},
	},
	'bunny-hood': {
		name: 'bunny hood',
		variations: {
			pink: 'Pink',
			yellow: 'Yellow',
			white: 'White',
		},
	},
	'captains-hat': {
		name: "captain's hat",
		variations: {
			white: 'White',
		},
	},
	'cat-cap': {
		name: 'cat cap',
		variations: {
			'navy-blue': 'Navy blue',
			brown: 'Brown',
			white: 'White',
		},
	},
	'catchers-mask': {
		name: "catcher's mask",
		variations: {
			red: 'Red',
			'navy-blue': 'Navy blue',
			green: 'Green',
			orange: 'Orange',
			yellow: 'Yellow',
		},
	},
	'cavalier-hat': {
		name: 'cavalier hat',
		variations: {
			blue: 'Blue',
			red: 'Red',
			green: 'Green',
		},
	},
	'chefs-hat': {
		name: "chef's hat",
		variations: {
			white: 'White',
		},
	},
	'cherry-hat': {
		name: 'cherry hat',
		variations: {
			red: 'Red',
		},
	},
	'chic-mum-crown': {
		name: 'chic mum crown',
		variations: {
			colorful: 'Colorful',
		},
	},
	'chic-rose-crown': {
		name: 'chic rose crown',
		variations: {
			purple: 'Purple',
		},
	},
	'chic-tulip-crown': {
		name: 'chic tulip crown',
		variations: {
			colorful: 'Colorful',
		},
	},
	'coin-headpiece': {
		name: 'coin headpiece',
		variations: {
			gold: 'Gold',
		},
	},
	'colorful-striped-knit-cap': {
		name: 'colorful striped knit cap',
		variations: {
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
			yellow: 'Yellow',
			purple: 'Purple',
			'light-blue': 'Light blue',
		},
	},
	'combat-helmet': {
		name: 'combat helmet',
		variations: {
			avocado: 'Avocado',
			brown: 'Brown',
		},
	},
	'composers-wig': {
		name: "composer's wig",
		variations: {
			'hair-color': 'Hair Color',
		},
	},
	'cool-hyacinth-crown': {
		name: 'cool hyacinth crown',
		variations: {
			blue: 'Blue',
		},
	},
	'cool-pansy-crown': {
		name: 'cool pansy crown',
		variations: {
			colorful: 'Colorful',
		},
	},
	'cool-windflower-crown': {
		name: 'cool windflower crown',
		variations: {
			colorful: 'Colorful',
		},
	},
	'cosmos-crown': {
		name: 'cosmos crown',
		variations: {
			colorful: 'Colorful',
		},
	},
	crown: {
		name: 'crown',
		variations: {
			gold: 'Gold',
		},
	},
	'cute-lily-crown': {
		name: 'cute lily crown',
		variations: {
			colorful: 'Colorful',
		},
	},
	'cute-rose-crown': {
		name: 'cute rose crown',
		variations: {
			colorful: 'Colorful',
		},
	},
	'cycling-cap': {
		name: 'cycling cap',
		variations: {
			blue: 'Blue',
			'black-and-blue': 'Black & blue',
			'black-and-red': 'Black & red',
			'yellow-and-avocado': 'Yellow & avocado',
			'red-and-green': 'Red & green',
			red: 'Red',
			'lime-and-purple': 'Lime & purple',
			'blue-and-purple': 'Blue & purple',
		},
	},
	'dal-cap': {
		name: 'DAL cap',
		variations: {
			blue: 'Blue',
		},
	},
	'dandy-hat': {
		name: 'dandy hat',
		variations: {
			camel: 'Camel',
			blue: 'Blue',
			green: 'Green',
			purple: 'Purple',
			gray: 'Gray',
			white: 'White',
		},
	},
	'dark-cosmos-crown': {
		name: 'dark cosmos crown',
		variations: {
			'dark-red': 'Dark red',
		},
	},
	'dark-lily-crown': {
		name: 'dark lily crown',
		variations: {
			'dark-red': 'Dark red',
		},
	},
	'dark-tulip-crown': {
		name: 'dark tulip crown',
		variations: {
			'dark-red': 'Dark red',
		},
	},
	'denim-cap': {
		name: 'denim cap',
		variations: {
			blue: 'Blue',
			'light-blue': 'Light blue',
			black: 'Black',
			white: 'White',
		},
	},
	'detective-hat': {
		name: 'detective hat',
		variations: {
			brown: 'Brown',
			gray: 'Gray',
			beige: 'Beige',
		},
	},
	'dj-cap': {
		name: 'DJ cap',
		variations: {
			blue: 'Blue',
			pink: 'Pink',
			orange: 'Orange',
			black: 'Black',
		},
	},
	'do-rag': {
		name: 'do-rag',
		variations: {
			yellow: 'Yellow',
			blue: 'Blue',
			red: 'Red',
			pink: 'Pink',
			black: 'Black',
			purple: 'Purple',
			green: 'Green',
			beige: 'Beige',
		},
	},
	'dotted-shower-cap': {
		name: 'dotted shower cap',
		variations: {
			pink: 'Pink',
			blue: 'Blue',
		},
	},
	'earth-egg-shell': {
		name: 'earth-egg shell',
		variations: {
			none: 'None',
		},
	},
	'egg-party-hat': {
		name: 'egg party hat',
		variations: {
			none: 'None',
		},
	},
	eggshell: {
		name: 'eggshell',
		variations: {
			white: 'White',
		},
	},
	'elder-mask': {
		name: 'elder mask',
		variations: {
			white: 'White',
		},
	},
	'elegant-hat': {
		name: 'elegant hat',
		variations: {
			purple: 'Purple',
			green: 'Green',
			red: 'Red',
			white: 'White',
			black: 'Black',
		},
	},
	'explorers-hat': {
		name: "explorer's hat",
		variations: {
			camel: 'Camel',
			avocado: 'Avocado',
			beige: 'Beige',
			blue: 'Blue',
		},
	},
	'fairy-tale-hood': {
		name: 'fairy-tale hood',
		variations: {
			red: 'Red',
			pink: 'Pink',
			yellow: 'Yellow',
			green: 'Green',
			blue: 'Blue',
			'light-blue': 'Light blue',
			'light-green': 'Light green',
			orange: 'Orange',
		},
	},
	'faux-fur-hat': {
		name: 'faux-fur hat',
		variations: {
			beige: 'Beige',
			brown: 'Brown',
			gray: 'Gray',
			black: 'Black',
			pink: 'Pink',
			white: 'White',
			red: 'Red',
		},
	},
	fedora: {
		name: 'fedora',
		variations: {
			beige: 'Beige',
			black: 'Black',
			green: 'Green',
			gray: 'Gray',
			white: 'White',
			red: 'Red',
		},
	},
	'firefighters-hat': {
		name: "firefighter's hat",
		variations: {
			black: 'Black',
			'flame-orange': 'Flame orange',
			brown: 'Brown',
			'lime-yellow': 'Lime yellow',
			avocado: 'Avocado',
		},
	},
	'flashy-hairpin': {
		name: 'flashy hairpin',
		variations: {
			pink: 'Pink',
			blue: 'Blue',
			black: 'Black',
			purple: 'Purple',
			orange: 'Orange',
			green: 'Green',
			white: 'White',
		},
	},
	'floral-hairpin': {
		name: 'floral hairpin',
		variations: {
			pink: 'Pink',
			blue: 'Blue',
			green: 'Green',
			yellow: 'Yellow',
			purple: 'Purple',
		},
	},
	'football-helmet': {
		name: 'football helmet',
		variations: {
			green: 'Green',
			white: 'White',
			yellow: 'Yellow',
			'berry-red': 'Berry red',
			blue: 'Blue',
			turquoise: 'Turquoise',
			red: 'Red',
			black: 'Black',
		},
	},
	'fox-mask': {
		name: 'fox mask',
		variations: {
			white: 'White',
			black: 'Black',
		},
	},
	'frog-cap': {
		name: 'frog cap',
		variations: {
			green: 'Green',
			blue: 'Blue',
			red: 'Red',
			yellow: 'Yellow',
		},
	},
	'frugal-hat': {
		name: 'frugal hat',
		variations: {
			brown: 'Brown',
			green: 'Green',
			'blue-gray': 'Blue-gray',
		},
	},
	'geisha-wig': {
		name: 'geisha wig',
		variations: {
			red: 'Red',
			pink: 'Pink',
			'golden-yellow': 'Golden yellow',
			green: 'Green',
			blue: 'Blue',
			purple: 'Purple',
			black: 'Black',
		},
	},
	'giant-ribbon': {
		name: 'giant ribbon',
		variations: {
			red: 'Red',
			green: 'Green',
			blue: 'Blue',
			yellow: 'Yellow',
			orange: 'Orange',
			pink: 'Pink',
			white: 'White',
			black: 'Black',
		},
	},
	glengarry: {
		name: 'glengarry',
		variations: {
			black: 'Black',
		},
	},
	'gold-helmet': {
		name: 'gold helmet',
		variations: {
			gold: 'Gold',
		},
	},
	'gold-rose-crown': {
		name: 'gold rose crown',
		variations: {
			gold: 'Gold',
		},
	},
	'gothic-headdress': {
		name: 'gothic headdress',
		variations: {
			purple: 'Purple',
			black: 'Black',
			red: 'Red',
			pink: 'Pink',
			blue: 'Blue',
			'light-purple': 'Light purple',
		},
	},
	'grape-hat': {
		name: 'grape hat',
		variations: {
			purple: 'Purple',
		},
	},
	halo: {
		name: 'halo',
		variations: {
			gold: 'Gold',
		},
	},
	headband: {
		name: 'headband',
		variations: {
			pink: 'Pink',
			blue: 'Blue',
			purple: 'Purple',
			green: 'Green',
		},
	},
	headgear: {
		name: 'headgear',
		variations: {
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
		},
	},
	headkerchief: {
		name: 'headkerchief',
		variations: {
			green: 'Green',
		},
	},
	'heart-hairpin': {
		name: 'heart hairpin',
		variations: {
			pink: 'Pink',
			red: 'Red',
			green: 'Green',
			blue: 'Blue',
			black: 'Black',
		},
	},
	'helmet-with-goggles': {
		name: 'helmet with goggles',
		variations: {
			pink: 'Pink',
			green: 'Green',
			purple: 'Purple',
			blue: 'Blue',
			red: 'Red',
			'light-blue': 'Light blue',
			black: 'Black',
			yellow: 'Yellow',
		},
	},
	'hibiscus-hairpin': {
		name: 'hibiscus hairpin',
		variations: {
			red: 'Red',
			yellow: 'Yellow',
			white: 'White',
			pink: 'Pink',
		},
	},
	'hockey-mask': {
		name: 'hockey mask',
		variations: {
			white: 'White',
		},
	},
	'hot-dog-hood': {
		name: 'hot-dog hood',
		variations: {
			red: 'Red',
		},
	},
	'hyacinth-crown': {
		name: 'hyacinth crown',
		variations: {
			red: 'Red',
		},
	},
	'imitation-cow-skull': {
		name: 'imitation cow skull',
		variations: {
			white: 'White',
		},
	},
	'imp-hood': {
		name: 'imp hood',
		variations: {
			black: 'Black',
			red: 'Red',
		},
	},
	'jesters-cap': {
		name: "jester's cap",
		variations: {
			'purple-and-yellow': 'Purple & yellow',
			'black-and-white': 'Black & white',
			'red-and-blue': 'Red & blue',
			'green-and-red': 'Green & red',
		},
	},
	'jockeys-helmet': {
		name: "jockey's helmet",
		variations: {
			pink: 'Pink',
			orange: 'Orange',
			green: 'Green',
			yellow: 'Yellow',
			blue: 'Blue',
			red: 'Red',
			black: 'Black',
			white: 'White',
		},
	},
	kaffiyeh: {
		name: 'kaffiyeh',
		variations: {
			white: 'White',
			red: 'Red',
			black: 'Black',
		},
	},
	'kappa-cap': {
		name: 'kappa cap',
		variations: {
			green: 'Green',
			pink: 'Pink',
		},
	},
	'kiwi-hat': {
		name: 'kiwi hat',
		variations: {
			green: 'Green',
		},
	},
	'knights-helmet': {
		name: "knight's helmet",
		variations: {
			gray: 'Gray',
		},
	},
	'knit-cap-with-earflaps': {
		name: 'knit cap with earflaps',
		variations: {
			beige: 'Beige',
			blue: 'Blue',
			pink: 'Pink',
			green: 'Green',
			'ruby-red': 'Ruby red',
			'moss-green': 'Moss green',
			gray: 'Gray',
		},
	},
	'knit-hat': {
		name: 'knit hat',
		variations: {
			black: 'Black',
			white: 'White',
			gray: 'Gray',
			ochre: 'Ochre',
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
			pink: 'Pink',
		},
	},
	'labelle-cap': {
		name: 'Labelle cap',
		variations: {
			twilight: 'Twilight',
			midnight: 'Midnight',
			passion: 'Passion',
			ocean: 'Ocean',
			sunset: 'Sunset',
			love: 'Love',
		},
	},
	'labelle-hat': {
		name: 'Labelle hat',
		variations: {
			twilight: 'Twilight',
			midnight: 'Midnight',
			passion: 'Passion',
			ocean: 'Ocean',
			sunset: 'Sunset',
			love: 'Love',
		},
	},
	'leaf-mask': {
		name: 'leaf mask',
		variations: {
			green: 'Green',
		},
	},
	'leaf-egg-shell': {
		name: 'leaf-egg shell',
		variations: {
			none: 'None',
		},
	},
	'lettered-cap': {
		name: 'lettered cap',
		variations: {
			red: 'Red',
			beige: 'Beige',
			olive: 'Olive',
		},
	},
	'lily-crown': {
		name: 'lily crown',
		variations: {
			colorful: 'Colorful',
		},
	},
	'lovely-cosmos-crown': {
		name: 'lovely cosmos crown',
		variations: {
			colorful: 'Colorful',
		},
	},
	'mages-hat': {
		name: "mage's hat",
		variations: {
			black: 'Black',
			blue: 'Blue',
			white: 'White',
			red: 'Red',
		},
	},
	matanpushi: {
		name: 'matanpushi',
		variations: {
			blue: 'Blue',
			brown: 'Brown',
			red: 'Red',
		},
	},
	'matronly-bun': {
		name: 'matronly bun',
		variations: {
			'hair-color': 'Hair Color',
		},
	},
	'mesh-cap': {
		name: 'mesh cap',
		variations: {
			purple: 'Purple',
			red: 'Red',
			pink: 'Pink',
			green: 'Green',
			orange: 'Orange',
			yellow: 'Yellow',
			black: 'Black',
		},
	},
	'milkmaid-hat': {
		name: 'milkmaid hat',
		variations: {
			white: 'White',
		},
	},
	'mohawk-wig': {
		name: 'mohawk wig',
		variations: {
			'hair-color': 'Hair Color',
		},
	},
	'mum-crown': {
		name: 'mum crown',
		variations: {
			colorful: 'Colorful',
		},
	},
	'mummy-mask': {
		name: 'mummy mask',
		variations: {
			white: 'White',
		},
	},
	'new-years-hat': {
		name: "New Year's hat",
		variations: {
			blue: 'Blue',
			green: 'Green',
			'light-blue': 'Light blue',
			orange: 'Orange',
			pink: 'Pink',
			purple: 'Purple',
			red: 'Red',
			yellow: 'Yellow',
		},
	},
	'new-years-silk-hat': {
		name: "New Year's silk hat",
		variations: {
			blue: 'Blue',
			green: 'Green',
			'light-blue': 'Light blue',
			orange: 'Orange',
			pink: 'Pink',
			purple: 'Purple',
			red: 'Red',
			yellow: 'Yellow',
		},
	},
	'ninja-hood': {
		name: 'ninja hood',
		variations: {
			'dark-blue': 'Dark blue',
			gray: 'Gray',
			red: 'Red',
			purple: 'Purple',
			aqua: 'Aqua',
			green: 'Green',
			yellow: 'Yellow',
			orange: 'Orange',
		},
	},
	'noh-mask': {
		name: 'Noh mask',
		variations: {
			white: 'White',
		},
	},
	'nook-inc-bandanna': {
		name: 'Nook Inc. bandanna',
		variations: {
			yellow: 'Yellow',
		},
	},
	'nook-inc-cap': {
		name: 'Nook Inc. cap',
		variations: {
			green: 'Green',
		},
	},
	'nurses-cap': {
		name: "nurse's cap",
		variations: {
			pink: 'Pink',
			white: 'White',
			blue: 'Blue',
		},
	},
	'ok-motors-cap': {
		name: 'OK Motors cap',
		variations: {
			na: 'NA',
		},
	},
	'orange-hat': {
		name: 'orange hat',
		variations: {
			orange: 'Orange',
		},
	},
	'outback-hat': {
		name: 'outback hat',
		variations: {
			brown: 'Brown',
			beige: 'Beige',
			red: 'Red',
			pink: 'Pink',
			white: 'White',
		},
	},
	'outdoor-hat': {
		name: 'outdoor hat',
		variations: {
			orange: 'Orange',
			blue: 'Blue',
			purple: 'Purple',
			red: 'Red',
			yellow: 'Yellow',
			'light-blue': 'Light blue',
			green: 'Green',
			beige: 'Beige',
		},
	},
	'paintball-mask': {
		name: 'paintball mask',
		variations: {
			black: 'Black',
			white: 'White',
			olive: 'Olive',
			yellow: 'Yellow',
		},
	},
	'paisley-bandanna': {
		name: 'paisley bandanna',
		variations: {
			red: 'Red',
			blue: 'Blue',
			yellow: 'Yellow',
			black: 'Black',
			green: 'Green',
			orange: 'Orange',
			pink: 'Pink',
			purple: 'Purple',
		},
	},
	'pansy-crown': {
		name: 'pansy crown',
		variations: {
			colorful: 'Colorful',
		},
	},
	'paper-bag': {
		name: 'paper bag',
		variations: {
			beige: 'Beige',
		},
	},
	'paperboy-cap': {
		name: 'paperboy cap',
		variations: {
			brown: 'Brown',
			gray: 'Gray',
			green: 'Green',
			blue: 'Blue',
			red: 'Red',
		},
	},
	'patchwork-tulip-hat': {
		name: 'patchwork tulip hat',
		variations: {
			pink: 'Pink',
			blue: 'Blue',
			yellow: 'Yellow',
		},
	},
	'peach-hat': {
		name: 'peach hat',
		variations: {
			peach: 'Peach',
		},
	},
	'pear-hat': {
		name: 'pear hat',
		variations: {
			green: 'Green',
		},
	},
	pigtail: {
		name: 'pigtail',
		variations: {
			'hair-color': 'Hair Color',
		},
	},
	'pilots-cap': {
		name: "pilot's cap",
		variations: {
			brown: 'Brown',
			black: 'Black',
			avocado: 'Avocado',
		},
	},
	'pilots-hat': {
		name: "pilot's hat",
		variations: {
			'navy-blue': 'Navy blue',
			black: 'Black',
			'light-blue': 'Light blue',
		},
	},
	'pineapple-cap': {
		name: 'pineapple cap',
		variations: {
			yellow: 'Yellow',
		},
	},
	'plain-cap': {
		name: 'plain cap',
		variations: {
			gray: 'Gray',
			beige: 'Beige',
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
		},
	},
	'police-cap': {
		name: 'police cap',
		variations: {
			'navy-blue': 'Navy blue',
		},
	},
	'pom-casquette': {
		name: 'pom casquette',
		variations: {
			brown: 'Brown',
			white: 'White',
			red: 'Red',
			green: 'Green',
			blue: 'Blue',
			gray: 'Gray',
		},
	},
	'pompadour-wig': {
		name: 'pompadour wig',
		variations: {
			'hair-color': 'Hair Color',
		},
	},
	'power-helmet': {
		name: 'power helmet',
		variations: {
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
			black: 'Black',
		},
	},
	'purple-hyacinth-crown': {
		name: 'purple hyacinth crown',
		variations: {
			purple: 'Purple',
		},
	},
	'purple-pansy-crown': {
		name: 'purple pansy crown',
		variations: {
			purple: 'Purple',
		},
	},
	'purple-windflower-crown': {
		name: 'purple windflower crown',
		variations: {
			purple: 'Purple',
		},
	},
	'racing-helmet': {
		name: 'racing helmet',
		variations: {
			red: 'Red',
			white: 'White',
			black: 'Black',
			blue: 'Blue',
			pink: 'Pink',
			green: 'Green',
			purple: 'Purple',
			'light-blue': 'Light blue',
		},
	},
	'rain-hat': {
		name: 'rain hat',
		variations: {
			yellow: 'Yellow',
			green: 'Green',
			pink: 'Pink',
			blue: 'Blue',
			red: 'Red',
			black: 'Black',
			purple: 'Purple',
			beige: 'Beige',
		},
	},
	ribbon: {
		name: 'ribbon',
		variations: {
			green: 'Green',
			red: 'Red',
			blue: 'Blue',
			yellow: 'Yellow',
			orange: 'Orange',
			pink: 'Pink',
			white: 'White',
			black: 'Black',
		},
	},
	'ribboned-garden-hat': {
		name: 'ribboned garden hat',
		variations: {
			blue: 'Blue',
			pink: 'Pink',
			black: 'Black',
			brown: 'Brown',
		},
	},
	'ribboned-straw-hat': {
		name: 'ribboned straw hat',
		variations: {
			'light-blue': 'Light blue',
			pink: 'Pink',
			black: 'Black',
		},
	},
	'rose-crown': {
		name: 'rose crown',
		variations: {
			colorful: 'Colorful',
		},
	},
	'royal-crown': {
		name: 'royal crown',
		variations: {
			red: 'Red',
		},
	},
	'safety-helmet': {
		name: 'safety helmet',
		variations: {
			yellow: 'Yellow',
			blue: 'Blue',
			orange: 'Orange',
			green: 'Green',
			black: 'Black',
		},
	},
	'sailors-hat': {
		name: "sailor's hat",
		variations: {
			white: 'White',
			'navy-blue': 'Navy blue',
			blue: 'Blue',
		},
	},
	'samurai-helmet': {
		name: 'samurai helmet',
		variations: {
			red: 'Red',
			black: 'Black',
			blue: 'Blue',
			white: 'White',
			'golden-yellow': 'Golden yellow',
		},
	},
	'samurai-wig': {
		name: 'samurai wig',
		variations: {
			'hair-color': 'Hair Color',
		},
	},
	'scholars-hat': {
		name: "scholar's hat",
		variations: {
			red: 'Red',
			green: 'Green',
			blue: 'Blue',
			yellow: 'Yellow',
		},
	},
	'school-hat': {
		name: 'school hat',
		variations: {
			yellow: 'Yellow',
			'navy-blue': 'Navy blue',
		},
	},
	'shallow-knit-cap': {
		name: 'shallow knit cap',
		variations: {
			green: 'Green',
			beige: 'Beige',
			'navy-blue': 'Navy blue',
			red: 'Red',
			purple: 'Purple',
			gray: 'Gray',
			brown: 'Brown',
		},
	},
	'sheep-hood': {
		name: 'sheep hood',
		variations: {
			white: 'White',
			pink: 'Pink',
			'light-blue': 'Light blue',
			brown: 'Brown',
		},
	},
	'silk-hat': {
		name: 'silk hat',
		variations: {
			green: 'Green',
			blue: 'Blue',
			yellow: 'Yellow',
			black: 'Black',
		},
	},
	'simple-mum-crown': {
		name: 'simple mum crown',
		variations: {
			green: 'Green',
		},
	},
	'skateboarding-helmet': {
		name: 'skateboarding helmet',
		variations: {
			orange: 'Orange',
			olive: 'Olive',
			gray: 'Gray',
			white: 'White',
			'light-blue': 'Light blue',
		},
	},
	'skeleton-hood': {
		name: 'skeleton hood',
		variations: {
			white: 'White',
		},
	},
	'ski-mask': {
		name: 'ski mask',
		variations: {
			green: 'Green',
			black: 'Black',
			lime: 'Lime',
			red: 'Red',
			blue: 'Blue',
		},
	},
	'sky-egg-shell': {
		name: 'sky-egg shell',
		variations: {
			none: 'None',
		},
	},
	'small-silk-hat': {
		name: 'small silk hat',
		variations: {
			purple: 'Purple',
			black: 'Black',
			red: 'Red',
		},
	},
	'snowperson-head': {
		name: 'snowperson head',
		variations: {
			white: 'White',
		},
	},
	'snowy-knit-cap': {
		name: 'snowy knit cap',
		variations: {
			blue: 'Blue',
			black: 'Black',
			brown: 'Brown',
			pink: 'Pink',
			green: 'Green',
			orange: 'Orange',
			red: 'Red',
			white: 'White',
		},
	},
	'soft-serve-hat': {
		name: 'soft-serve hat',
		variations: {
			vanilla: 'Vanilla',
			chocolate: 'Chocolate',
			'gold-leaf': 'Gold leaf',
			strawberry: 'Strawberry',
			'green-tea': 'Green tea',
			'pale-sky': 'Pale sky',
			'purple-sweet-potato': 'Purple sweet potato',
			'black-sesame': 'Black sesame',
		},
	},
	sombrero: {
		name: 'sombrero',
		variations: {
			'natural-and-red': 'Natural & red',
			'natural-and-green': 'Natural & green',
			'navy-blue': 'Navy blue',
			green: 'Green',
			white: 'White',
			red: 'Red',
			blue: 'Blue',
			orange: 'Orange',
		},
	},
	'space-helmet': {
		name: 'space helmet',
		variations: {
			white: 'White',
		},
	},
	'sports-cap': {
		name: 'sports cap',
		variations: {
			red: 'Red',
			'white-and-red': 'White & red',
			blue: 'Blue',
			'white-and-blue': 'White & blue',
		},
	},
	'stagehand-hat': {
		name: 'stagehand hat',
		variations: {
			black: 'Black',
		},
	},
	'star-hairpin': {
		name: 'star hairpin',
		variations: {
			yellow: 'Yellow',
			pink: 'Pink',
			purple: 'Purple',
			mint: 'Mint',
			black: 'Black',
		},
	},
	'star-head': {
		name: 'star head',
		variations: {
			yellow: 'Yellow',
		},
	},
	'stone-egg-shell': {
		name: 'stone-egg shell',
		variations: {
			none: 'None',
		},
	},
	'straw-boater': {
		name: 'straw boater',
		variations: {
			cream: 'Cream',
			beige: 'Beige',
			'light-brown': 'Light brown',
			brown: 'Brown',
			'dark-brown': 'Dark brown',
			monotone: 'Monotone',
			'light-blue': 'Light blue',
			pink: 'Pink',
		},
	},
	'straw-hat': {
		name: 'straw hat',
		variations: {
			brown: 'Brown',
			blue: 'Blue',
			red: 'Red',
		},
	},
	'straw-umbrella-hat': {
		name: 'straw umbrella hat',
		variations: {
			brown: 'Brown',
		},
	},
	'strawberry-hat': {
		name: 'strawberry hat',
		variations: {
			red: 'Red',
		},
	},
	'student-cap': {
		name: 'student cap',
		variations: {
			black: 'Black',
			'berry-red': 'Berry red',
			green: 'Green',
			white: 'White',
			purple: 'Purple',
			gray: 'Gray',
			blue: 'Blue',
		},
	},
	'sushi-chef-hat': {
		name: 'sushi chef hat',
		variations: {
			white: 'White',
			'dark-blue': 'Dark blue',
		},
	},
	'swimming-cap': {
		name: 'swimming cap',
		variations: {
			yellow: 'Yellow',
			'light-blue': 'Light blue',
			red: 'Red',
			white: 'White',
			black: 'Black',
			blue: 'Blue',
			pink: 'Pink',
			green: 'Green',
		},
	},
	'tam-o-shanter': {
		name: "tam-o'-shanter",
		variations: {
			red: 'Red',
			gray: 'Gray',
			blue: 'Blue',
			green: 'Green',
		},
	},
	'terry-cloth-do-rag': {
		name: 'terry-cloth do-rag',
		variations: {
			white: 'White',
			black: 'Black',
			blue: 'Blue',
			brown: 'Brown',
			yellow: 'Yellow',
			'berry-red': 'Berry red',
		},
	},
	'terry-cloth-nightcap': {
		name: 'terry-cloth nightcap',
		variations: {
			'light-blue': 'Light blue',
			blue: 'Blue',
			green: 'Green',
			orange: 'Orange',
			pink: 'Pink',
			cream: 'Cream',
			purple: 'Purple',
			lime: 'Lime',
		},
	},
	tiara: {
		name: 'tiara',
		variations: {
			silver: 'Silver',
			'rose-gold': 'Rose gold',
			gold: 'Gold',
		},
	},
	'tiara-hair': {
		name: 'tiara hair',
		variations: {
			silver: 'Silver',
			gold: 'Gold',
			'rose-gold': 'Rose gold',
		},
	},
	'top-hat': {
		name: 'top hat',
		variations: {
			black: 'Black',
			white: 'White',
			brown: 'Brown',
			purple: 'Purple',
			red: 'Red',
			blue: 'Blue',
		},
	},
	'tropical-hat': {
		name: 'tropical hat',
		variations: {
			mint: 'Mint',
			white: 'White',
			blue: 'Blue',
			yellow: 'Yellow',
			pink: 'Pink',
		},
	},
	tubeteika: {
		name: 'tubeteika',
		variations: {
			red: 'Red',
			blue: 'Blue',
			camel: 'Camel',
			purple: 'Purple',
		},
	},
	'tulip-crown': {
		name: 'tulip crown',
		variations: {
			colorful: 'Colorful',
		},
	},
	'tulip-hat': {
		name: 'tulip hat',
		variations: {
			orange: 'Orange',
			brown: 'Brown',
			camel: 'Camel',
		},
	},
	turban: {
		name: 'turban',
		variations: {
			purple: 'Purple',
			blue: 'Blue',
			pink: 'Pink',
			yellow: 'Yellow',
		},
	},
	'tweed-cap': {
		name: 'tweed cap',
		variations: {
			brown: 'Brown',
			blue: 'Blue',
			green: 'Green',
		},
	},
	veil: {
		name: 'veil',
		variations: {
			blue: 'Blue',
			purple: 'Purple',
			pink: 'Pink',
			yellow: 'Yellow',
		},
	},
	'veiled-gardening-hat': {
		name: 'veiled gardening hat',
		variations: {
			pink: 'Pink',
			blue: 'Blue',
			orange: 'Orange',
			green: 'Green',
			purple: 'Purple',
		},
	},
	'viking-helmet': {
		name: 'viking helmet',
		variations: {
			gray: 'Gray',
			brown: 'Brown',
			blue: 'Blue',
		},
	},
	'visual-punk-wig': {
		name: 'visual-punk wig',
		variations: {
			'hair-color': 'Hair Color',
		},
	},
	'water-egg-shell': {
		name: 'water-egg shell',
		variations: {
			none: 'None',
		},
	},
	'watermelon-hat': {
		name: 'watermelon hat',
		variations: {
			red: 'Red',
		},
	},
	'welding-mask': {
		name: 'welding mask',
		variations: {
			red: 'Red',
		},
	},
	'wide-brim-straw-hat': {
		name: 'wide-brim straw hat',
		variations: {
			black: 'Black',
			beige: 'Beige',
			white: 'White',
		},
	},
	'windflower-crown': {
		name: 'windflower crown',
		variations: {
			colorful: 'Colorful',
		},
	},
	'wizards-cap': {
		name: "wizard's cap",
		variations: {
			blue: 'Blue',
			purple: 'Purple',
		},
	},
	'wood-egg-shell': {
		name: 'wood-egg shell',
		variations: {
			none: 'None',
		},
	},
	'wrestling-mask': {
		name: 'wrestling mask',
		variations: {
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
			pink: 'Pink',
			black: 'Black',
			yellow: 'Yellow',
		},
	},
	'zap-helmet': {
		name: 'zap helmet',
		variations: {
			pink: 'Pink',
			blue: 'Blue',
			green: 'Green',
			red: 'Red',
			yellow: 'Yellow',
			black: 'Black',
			silver: 'Silver',
			white: 'White',
		},
	},
	'zen-hair-clip': {
		name: 'zen hair clip',
		variations: {
			red: 'Red',
			aqua: 'Aqua',
			'dark-blue': 'Dark blue',
			'golden-yellow': 'Golden yellow',
			purple: 'Purple',
			pink: 'Pink',
			green: 'Green',
			'sky-blue': 'Sky blue',
		},
	},
};

export { _headwear };
